import AgencyIcon from "./AgencyIcon";
import ClubIcon from "./ClubIcon";
import CreatemusicvenueIcon from "./CreatemusicvenueIcon";
import CultureofficeIcon from "./CultureofficeIcon";
import FestivalIcon from "./FestivalIcon";
import FundingnetworksIcon from "./FundingnetworksIcon";
import LabelIcon from "./LabelIcon";
import MusicpublisherIcon from "./MusicpublisherIcon";
import MusicschoolIcon from "./MusicschoolIcon";
import RecordsaleIcon from "./RecordsaleIcon";
import RehearsalspaceIcon from "./RehearsalspaceIcon";
import StudioIcon from "./StudioIcon";
import UniversityIcon from "./UniversityIcon";
import VenueIcon from "./VenueIcon";

export default function LocationIcon({ category }) {
  const ICONS = [
    { venue: <VenueIcon /> },
    { createmusicvenue: <CreatemusicvenueIcon /> },
    { club: <ClubIcon /> },
    { cultureoffice: <CultureofficeIcon /> },
    { rehearsalspace: <RehearsalspaceIcon /> },
    { label: <LabelIcon /> },
    { studio: <StudioIcon /> },
    { musicpublisher: <MusicpublisherIcon /> },
    { musicschool: <MusicschoolIcon /> },
    { festival: <FestivalIcon /> },
    { university: <UniversityIcon /> },
    { recordsale: <RecordsaleIcon /> },
    { fundingnetwork: <FundingnetworksIcon /> },
    { agency: <AgencyIcon /> },
  ];

  return ICONS.find((icon) => icon[category.icon])?.[category.icon];
}
